import { IOpCode } from "@/PayPlans/types/sections/technicians";
interface IAward {
	_id: string;
	spiffEntry: Date;
	spiffDate: Date;
	recipient: string;
	stocks: string[];
	createdAt: Date;
	createdBy: string;
	updatedBy: string;
}

interface IItem {
	_id: string;
	rolloverCounter: number;
	title: string;
	effectiveDateRangeFrom: Date;
	effectiveDateRangeTo: Date;
	reward: number;
	awardsCount: number;
	awards: IAward[];
	createdAt: Date;
	createdBy: string;
	updatedBy: string;
	updatedAt: Date;
	spiffType: string;
	eligibility: IEligibilityRequirement;
	eligibilityDays: string[];
	requiredDealStatus: string;
}

interface IInputValue {
	input: string;
	value: number;
}

//@ts-ignore
type TTierCommission = Record<string, InputType>;

interface ITiers {
	from: IInputValue;
	to: IInputValue;
	commissions: TTierCommission[];
}

interface ISpiffSetupRule {
	_id: string;
	make: string;
	model: string;
	trim: string;
	status: string[];
	rangeType: string;
	startYear: string;
	endYear: string;
	stockExpression: string;
}

interface IEligibilityRequirement {
	rules?: ISpiffSetupRule[];
	tiers: ITiers[];
	applyTiersRetroactively: boolean;
	genericValue?: string;
	pvrType?: string;
	requiredStoreUnits?: number;
	requiredPvr?: number | null;
	franchises?: string[];
	selectedDepartment?: string[];
	selectedPayType?: string[];
	selectedOperationCodes?: IOpCode[];
	selectedTimeLapse?: string;
	component: string;
}

interface ISpiffSetup {
	_id: string;
	title: string;
	effectiveDateFrom: Date;
	effectiveDateTo: Date;
	itemsCount: number;
	items: IItem[];
	createdAt: Date;
	createdBy: string;
	lastModifiedOn: Date;
	lastModifiedBy: string;
}

interface OnActionUpdateParams {
	tabKey: string;
	index: number;
	modelToPropagate: IEligibilityRequirement;
	isValid: boolean;
}

export enum ESpiffTypes {
	GENERIC = "Generic",
	SALES = "Sales",
	TRADES = "Trades",
	GPS_COMPLIANCE = "GPS Compliance",
	DEPARTMENT = "Department",
	OP_CODES = "Op Codes",
}

export type {
	IAward,
	IItem,
	IInputValue,
	TTierCommission,
	ITiers,
	ISpiffSetupRule,
	IEligibilityRequirement,
	ISpiffSetup,
	OnActionUpdateParams,
};
